module.exports = __webpack_public_path__ + "img/1286678885.e4ce5f20.jpg";